"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var ColorItem_1 = require("./ColorItem");
var HandlePaletteColors = /** @class */ (function () {
    function HandlePaletteColors() {
    }
    HandlePaletteColors.getPaletteColors = function (color) {
        var newTheme = core_1.createMuiTheme();
        try {
            // use primary to calculate dark and light colors
            newTheme = this.createSingleColorPalette(color);
        }
        catch (e) {
        }
        return newTheme.palette.primary;
    };
    HandlePaletteColors.createSingleColorPalette = function (color) { return core_1.createMuiTheme({
        palette: {
            primary: {
                main: color
            },
        }
    }); };
    return HandlePaletteColors;
}());
exports.HandlePaletteColors = HandlePaletteColors;
var PickedColors = function (props) {
    var paletteColors = HandlePaletteColors.getPaletteColors(props.pickedColor);
    var light = paletteColors.light, dark = paletteColors.dark, main = paletteColors.main;
    return (react_1.default.createElement(core_1.Box, { display: 'flex' },
        react_1.default.createElement(ColorItem_1.ColorItem, { color: light }),
        react_1.default.createElement(ColorItem_1.ColorItem, { color: main }),
        react_1.default.createElement(ColorItem_1.ColorItem, { color: dark })));
};
exports.default = PickedColors;
